import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStudioDisplay: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="studio-display, thunderbolt"><path d="M8.75 17.25H2.75V4.75H21.25V17.25H15.25M8.75 17.25V20.25H15.25V17.25M8.75 17.25H15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconStudioDisplay;
